import styled, { css } from 'styled-components';
const Wrap = styled.div`
  background-color: #174489;
`;
const MessageWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: auto;
  padding: 16px 0;
  text-align: left;

  p {
    margin-bottom: 16px;
    color: white;
  }
  h4 {
    color: white;
    text-align: left;
    width: 100%;
    margin-bottom: 16px;
  }
  ${props => {
    if (props.isDesktop) {
      return desktopStyles;
    }
  }}
`;
const MessageBtnWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  button {
    &:first-child {
      padding: 16px 48px;
    }
  }
`;

const desktopStyles = css`
  flex-direction: row;
  height: 83px;
  h4 {
    width: auto;
    margin: 0;
  }
  p {
    margin: 0;
    padding-left: 16px;
    flex: 1;
  }

  ${MessageBtnWrap} {
    button {
      &:first-child {
        padding: 16px 20px;
      }
    }
  }
`;
export default { Wrap, MessageWrap, MessageBtnWrap };
